<script>
import { isComponent } from '@/v-shop/autoloader'

export default {
	lang: 'shop',
	inject: ['xcheckout'],
	computed: {
		checkout() {
			return this.xcheckout()
		},
	},
	methods: {
		compName(method) {
			return `${method.methodKey}-Payment-CheckoutOptions`
		},
		compExists(method) {
			return isComponent(this.compName(method))
		},
	},
}
</script>

<template>
	<CheckoutStepLayout :title="$lang('Elige la forma de pago')">
		<div v-for="(method, i) in checkout.stepViewData.paymentMethods" :key="i">
			<component
				v-if="compExists(method)"
				:is="compName(method)"
				:data="method.checkoutData"
				@optionSelected="
					checkout.stepSubmit({
						methodKey: method.methodKey,
						input: $event,
					})
				"
			/>
		</div>
	</CheckoutStepLayout>
</template>

<style></style>
